<template>

    <v-app id="weeklyBg">

        <v-layout row class="mt-6 ml-1 pb-12 px-lg-0 py-lg-0 px-2 py-5">
                                <v-form ref="form">             
                                    <v-flex lg12 xs12>
                                            <v-layout row>

                                                    <v-flex lg12>
                                                        <v-row>

                                                            <div> <v-img src="@/assets/images/Monitoring/assignment.svg"  aspect-ratio='1' contain max-width="100"/> </div> <span class="ml-2"> {{tutorName}} </span>

                                                        </v-row>
                                    

                                                    </v-flex>
                                                  

                                            </v-layout>
                                       
                                            

                                    </v-flex>

                                    <v-flex lg12 xs12 class="mt-lg-12 mt-12">
                                            <v-layout row>


                                                      <v-flex lg3 xs12>
                                                        <v-row>

                                                            <div> <v-img src="@/assets/images/Monitoring/team.svg"  aspect-ratio='1' contain max-width="30"/> </div> <template id="selectTeam">
                                                            <v-select v-model="teams"  :items="teamCat" item-text="category" item-value="value" single-line :rules="inputRules"   class="font12 font14 select-input ml-1 mt-n4"></v-select>
                                                            </template>

                                                        </v-row>
                                                    </v-flex>

                                                    <v-flex lg3 xs12 class="ml-lg-16 mt-lg-0 mt-10">
                                                        <v-row>

                                                            <div> <v-img src="@/assets/images/Monitoring/calendar.svg"  aspect-ratio='1' contain max-width="100"/> </div> 
                                                            <v-row>
                                                                <v-col cols="11" sm="6" md="4" lg="12">
                                                                <v-menu ref="menudate"  v-model="menudate" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition"
                                                                    offset-y min-width="auto">

                                                                    <template v-slot:activator="{ on, attrs }">
                                                                    <v-text-field :rules="inputRules" v-model="date" label="CLASS DATE" readonly v-bind="attrs" v-on="on" class="input-size mt-n4 ml-2"></v-text-field>
                                                                    </template>
                                                                    <v-date-picker v-model="date" no-title scrollable :min="rangeIsFrom" :max="rangeIsTo">
                                                                    <v-spacer></v-spacer>
                                                                    <v-btn text color="primary" @click="menudate = false">
                                                                        Cancel
                                                                    </v-btn>
                                                                    <v-btn text color="primary" @click="$refs.menudate.save(date)">
                                                                        OK
                                                                    </v-btn>
                                                                    </v-date-picker>
                                                                </v-menu>
                                                                </v-col>
                                                            </v-row>

                                                        </v-row>


                                                    </v-flex>

                                                    
                                                    <v-flex lg3 xs12 class="ml-lg-16 mt-lg-0 mt-10">
                                                        <v-row>

                                                            <div> <v-img src="@/assets/images/Monitoring/clock.svg"  aspect-ratio='1' contain max-width="20"/> </div>  
                                                            <v-row>
                                                                <v-col cols="11" sm="5" lg="12">
                                                                <v-menu ref="menu" v-model="menu2" :close-on-content-click="false" :nudge-right="40" :return-value.sync="time" transition="scale-transition"
                                                                    offset-y max-width="290px" min-width="290px"
                                                                >
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                    <v-text-field :rules="inputRules" v-model="time"  label="CLASS TIME" readonly v-bind="attrs" v-on="on" class="input-size mt-n4 ml-2"></v-text-field>
                                                                    </template>
                                                                    <v-time-picker v-if="menu2" v-model="time"
                                                                    full-width
                                                                    format="24hr"
                                                                    @click:minute="$refs.menu.save(time)"
                                                                    ></v-time-picker>
                                                                </v-menu>
                                                                </v-col>
                                                        </v-row>

                                                        </v-row>
                                                    </v-flex>
                                            </v-layout>
                                       
                                            

                                    </v-flex>

                                    <v-flex lg12 xs12 class="mt-15 ml-n3">
                                            <v-layout>

                                                    <v-flex lg12 xs12>
                                                        <v-row>

                                                            <div> <v-img src="@/assets/images/Monitoring/linked.svg"   aspect-ratio='1' contain max-width="100"/> </div> <v-text-field :rules="inputRules" label="LINK TO CLASS RECORDING" class="mt-n4 ml-2" v-model="linked"></v-text-field>

                                                        </v-row>
                                    

                                                    </v-flex>
                                            </v-layout>
                                       
                                            

                                    </v-flex>   

                                     <v-flex lg12 xs12 class="mt-10">


                                            <v-layout class="px-lg-16 px-2 py-5 font-weight-bold header">

                                                
                                                    <v-flex lg12>
                                                        
                                                        Criteria

                                                    </v-flex>
                                                      <v-flex lg6 class="ml-10">
                                                        
                                                        <v-row class="ml-16">

                                                            <v-col lg="3">
                                                                    Yes
                                                            </v-col>
                                                            <v-col lg="3" class="ml-lg-5 ml-1">
                                                                    No
                                                            </v-col>

                                                        </v-row>

                                                    </v-flex>
                                                    
                                            </v-layout>
                                       
                                            

                                    </v-flex>   

                                     <v-flex lg12 xs12 class=" criteria px-lg-0 px-2">


                                            <v-layout class="px-lg-12 py-lg-5 text-body-2" >

                                                
                                                    <v-flex lg10 xs8 class="mt-lg-0 mt-2">
                                                        
                                                        1. Teacher calls on time and ends on time.

                                                    </v-flex>
                                                    <v-flex lg6 xs6 class="ml-lg-16">
                                                        
                                                        <v-row class="ml-lg-10 mt-lg-n1 mt-1">

                                                           
                                                                <v-radio-group v-model="onecri">
                                                                     <v-row class="ml-10">

                                                                            <v-radio value="" style="display:none"></v-radio>

                                                                            <v-radio value="1.5"></v-radio>
                                                                            
                                                                    
                                                                            <v-radio value="0" class="mt-n2 ml-lg-2 ml-8"></v-radio>
                                                                     </v-row>
                                                                </v-radio-group>

                                                        </v-row>

                                                    </v-flex>
                                                    
                                            </v-layout>
                                            <v-layout class="px-lg-12 py-lg-5 text-body-2 mt-lg-n5">

                                                
                                                    <v-flex lg10 xs8  class="mt-lg-0 mt-2">
                                                        
                                                        2. Teacher strictly follows the class format.

                                                    </v-flex>
                                                    <v-flex lg6 xs6 class="ml-lg-16">
                                                        
                                                        <v-row class="ml-lg-10 mt-lg-n1 mt-1">

                                                           
                                                                <v-radio-group v-model="twocri">
                                                                     <v-row class="ml-10">

                                                                            <v-radio value="" style="display:none"></v-radio>
                                                                            <v-radio value="1.5"></v-radio>
                                                                    
                                                                            <v-radio value="0" class="mt-n2 ml-lg-2 ml-8"></v-radio>
                                                                     </v-row>
                                                                </v-radio-group>

                                                        </v-row>

                                                    </v-flex>
                                                    
                                            </v-layout>
                                            <v-layout class="px-lg-12 py-lg-5 text-body-2 mt-lg-n5">

                                                
                                                    <v-flex lg10  xs8  class="mt-lg-0 mt-2">
                                                        
                                                        3. Teacher utilizes the given class material/curriculum.

                                                    </v-flex>
                                                    <v-flex lg6 xs6 class="ml-lg-16">
                                                        
                                                        <v-row class="ml-lg-10 mt-lg-n1 mt-1">

                                                           
                                                                <v-radio-group v-model="threecri">
                                                                     <v-row class="ml-10">
                                                                         
                                                                            <v-radio value="" style="display:none"></v-radio>
                                                                            <v-radio value="1.5"></v-radio>
                                                                    
                                                                            <v-radio value="0" class="mt-n2 ml-lg-2 ml-8"></v-radio>
                                                                     </v-row>
                                                                </v-radio-group>

                                                        </v-row>

                                                    </v-flex>
                                                    
                                            </v-layout>
                                            <v-layout class="px-lg-12 py-lg-5 text-body-2 mt-lg-n5">

                                                
                                                    <v-flex lg10 xs8 class="mt-lg-0 mt-2">
                                                        
                                                        4. Teacher completes class evaluation correctly and on time

                                                    </v-flex>
                                                    <v-flex lg6 xs6 class="ml-lg-16">
                                                        
                                                        <v-row class="ml-lg-10 mt-lg-n1 mt-1">

                                                           
                                                                <v-radio-group v-model="fourcri">
                                                                     <v-row class="ml-10">

                                                                            <v-radio value="" style="display:none"></v-radio>
                                                                            <v-radio value="1.5"></v-radio>
                                                                    
                                                                            <v-radio value="0" class="mt-n2 ml-lg-2 ml-8"></v-radio>
                                                                     </v-row>
                                                                </v-radio-group>

                                                        </v-row>

                                                    </v-flex>
                                                    
                                            </v-layout>
                                            <v-layout class="px-lg-12 py-lg-5 text-body-2 mt-lg-n5">

                                                
                                                    <v-flex lg10 xs8 class="mt-lg-0 mt-2">
                                                        
                                                        5. Teacher observes 70/30 student to teacher speaking rule.

                                                    </v-flex>
                                                    <v-flex lg6 xs6 class="ml-lg-16">
                                                        
                                                        <v-row class="ml-lg-10 mt-lg-n1 mt-1">

                                                           
                                                                <v-radio-group v-model="fivecri">
                                                                     <v-row class="ml-10">

                                                                            <v-radio value="" style="display:none"></v-radio>
                                                                            <v-radio value="1.5"></v-radio>
                                                                    
                                                                            <v-radio value="0" class="mt-n2 ml-lg-2 ml-8"></v-radio>
                                                                     </v-row>
                                                                </v-radio-group>

                                                        </v-row>

                                                    </v-flex>
                                                    
                                            </v-layout>
                                            <v-layout class="px-lg-12 py-lg-5 text-body-2 mt-lg-n5">

                                                
                                                    <v-flex lg10 xs8 class="mt-lg-0 mt-2">
                                                        
                                                        6. Teacher corrects the student in a timely manner.

                                                    </v-flex>
                                                    <v-flex lg6 xs6 class="ml-lg-16">
                                                        
                                                        <v-row class="ml-lg-10 mt-lg-n1 mt-1">

                                                           
                                                                <v-radio-group v-model="sixcri">
                                                                     <v-row class="ml-10">

                                                                            <v-radio value="" style="display:none"></v-radio>
                                                                            <v-radio value="1.5"></v-radio>
                                                                    
                                                                            <v-radio value="0" class="mt-n2 ml-lg-2 ml-8"></v-radio>
                                                                     </v-row>
                                                                </v-radio-group>

                                                        </v-row>

                                                    </v-flex>
                                                    
                                            </v-layout>
                                            <v-layout class="px-lg-12 py-lg-5 text-body-2 mt-lg-n5">

                                                
                                                    <v-flex lg10 xs8 class="mt-lg-0 mt-2">
                                                        
                                                        7. Teacher listens attentively and gives appropriate feedback to the student.

                                                    </v-flex>
                                                    <v-flex lg6 xs6 class="ml-lg-16">
                                                        
                                                        <v-row class="ml-lg-10 mt-lg-n1 mt-1">

                                                           
                                                                <v-radio-group v-model="sevencri">
                                                                     <v-row class="ml-10">

                                                                            <v-radio value="" style="display:none"></v-radio>
                                                                            <v-radio value="1.5"></v-radio>
                                                                    
                                                                            <v-radio value="0" class="mt-n2 ml-lg-2 ml-8"></v-radio>
                                                                     </v-row>
                                                                </v-radio-group>

                                                        </v-row>

                                                    </v-flex>
                                                    
                                            </v-layout>
                                            <v-layout class="px-lg-12 py-lg-5 text-body-2 mt-lg-n5">

                                                
                                                    <v-flex lg10 xs8 class="mt-lg-0 mt-2">
                                                        
                                                        8. Teacher has good accent and pronunciation.

                                                    </v-flex>
                                                    <v-flex lg6 xs6 class="ml-lg-16">
                                                        
                                                        <v-row class="ml-lg-10 mt-lg-n1 mt-1">

                                                           
                                                                <v-radio-group v-model="eightcri">
                                                                     <v-row class="ml-10">

                                                                            <v-radio value="" style="display:none"></v-radio>
                                                                            <v-radio value="1.5"></v-radio>
                                                                    
                                                                            <v-radio value="0" class="mt-n2 ml-lg-2 ml-8"></v-radio>
                                                                     </v-row>
                                                                </v-radio-group>

                                                        </v-row>

                                                    </v-flex>
                                                    
                                            </v-layout>
                                            <v-layout class="px-lg-12 py-lg-5 text-body-2 mt-lg-n5">

                                                
                                                    <v-flex lg10 xs8 class="mt-lg-0 mt-2">
                                                        
                                                        9. Teacher has good grammatical skills.

                                                    </v-flex>
                                                    <v-flex lg6 xs6 class="ml-lg-16">
                                                        
                                                        <v-row class="ml-lg-10 mt-lg-n1 mt-1">

                                                           
                                                                <v-radio-group v-model="ninecri">
                                                                     <v-row class="ml-10">


                                                                            <v-radio value="" style="display:none"></v-radio>
                                                                            <v-radio value="1.5"></v-radio>
                                                                    
                                                                            <v-radio value="0" class="mt-n2 ml-lg-2 ml-8"></v-radio>
                                                                     </v-row>
                                                                </v-radio-group>

                                                        </v-row>

                                                    </v-flex>
                                                    
                                            </v-layout>
                                            <v-layout class="px-lg-12 py-lg-5 text-body-2 mt-lg-n5">

                                                
                                                    <v-flex lg10 xs8 class="mt-lg-0 mt-2">
                                                        
                                                        10. Teacher shows good and appropriate attitude during the class.

                                                    </v-flex>
                                                    <v-flex lg6 xs6 class="ml-lg-16">
                                                        
                                                        <v-row class="ml-lg-10 mt-lg-n1 mt-1">

                                                           
                                                                <v-radio-group v-model="tencri">
                                                                     <v-row class="ml-10">

                                                                            <v-radio value="" style="display:none"></v-radio>
                                                                            <v-radio value="1.5"></v-radio>
                                                                    
                                                                            <v-radio value="0" class="mt-n2 ml-lg-2 ml-8"></v-radio>
                                                                     </v-row>
                                                                </v-radio-group>

                                                        </v-row>

                                                    </v-flex>
                                                    
                                            </v-layout>
                                       
                                           <span class="red--text"> {{radioFailed}} </span>

                                    </v-flex>
                                    <v-flex lg12 class="mt-lg-5 pb-5">
                                        
                                        <v-layout justify-end>
                                            <v-btn color="rgb(0, 99, 158)" class="white--text" @click="SaveCri()"> SUBMIT </v-btn>
                                        </v-layout>

                                    </v-flex>  

                                </v-form>
                                                    
                            </v-layout>

    </v-app>    


</template>
<script>
import Vue from 'vue'
import axios from 'axios'
export default {
    name: 'weeklyform',
    props:['wkReport','weekValue'],
    data: () => {
        return {
            dialogshow:false,
            swipeDirection: false,
            teams:'',
            teamCat: [
                {category:'AM',
                value:"am"},
                 {category:'PM'
                 ,value:"pm"}],
            tutorName:'',
            time: '',
            menu2: false,
            date:'',
            menudate: false,
            modal: false,
            menudate2: false,
            monthno: '',
            weekno:'',
            linked:'',
            rangeIsFrom:'',
            rangeIsTo:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            onecri:'',
            twocri:'',
            threecri:'',
            fourcri:'',
            fivecri:'',
            sixcri:'',
            sevencri:'',
            eightcri:'',
            ninecri:'',
            tencri:'',
            bus: new Vue(),
            radioFailed : '',
            inputRules: [
                v => v.length >= 1 || "Item is Required"
            ],
            classtimeerror:false,
            timestamp: new Date(),


        }
    },

    computed: {
        post(){
            return {
                        actionTaken:'InsertData',
                        event:"classHandling",
                        tutor_id : this.$route.params.t_id,
                        month: this.monthno,
                        week : this.weekno,
                        teams:this.teams,
                        date:this.date,
                        time:this.time,
                        linked:this.linked,
                        criteria : {
                                one:this.onecri,
                                two:this.twocri,
                                three:this.threecri,
                                four:this.fourcri,
                                five:this.fivecri,
                                six:this.sixcri,
                                seven:this.sevencri,
                                eight:this.eightcri,
                                nine:this.ninecri,
                                ten:this.tencri
                                
                        },
                        timestamp: this.timestamp.getFullYear()+"-"+(this.timestamp.getMonth() >= 9 ? (this.timestamp.getMonth()+1) : "0"+(this.timestamp.getMonth()+1))+"-"+(this.timestamp.getDate() > 9 ? this.timestamp.getDate() : "0"+this.timestamp.getDate())+" "+(this.timestamp.getHours() > 9 ? this.timestamp.getHours() : "0"+this.timestamp.getHours())+":"+(this.timestamp.getMinutes() > 9 ? this.timestamp.getMinutes() : "0"+this.timestamp.getMinutes())+":"+(this.timestamp.getSeconds() > 9 ? this.timestamp.getSeconds() : "0"+this.timestamp.getSeconds())


            }
        }
    },
    mounted(){


        axios.get('https://phone.megatalking.com/origin/api/monitoring.php?action=getTutors')
        //.then(response=>console.warn(response.data))
        .then(response=>{
        
          let tutorlist = response.data
        

              for(let i = 0 ; i<=tutorlist.length ; i++){
                    


                    if(this.$route.params.t_id.toString().toLowerCase().indexOf(tutorlist[i].tutor_id.toLowerCase()) !== -1){
                        this.tutorName = tutorlist[i].tutor_full_name
                    }

               }
               
              })

        this.wkReport.$on('getInfoAssessment', this.getInfoAssessment)  
        
    },
    watch:{
        
    },
    
    methods: {

        getInfoAssessment(){
           
            let id = this.weekValue
            this.weekno = id.no
            this.monthno = id.month
            Date.prototype.getWeek = function() {

                var date = new Date(this.getDate())
                date.setHours(0, 0, 0, 0)
            
                date.setDate(date.getDate() + 3 - (date.getDay() + 7) % 7)
                var week1 = new Date(date.getFullYear(), 0, 1)
                return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7)

            }

            var d1,d2,d3,d4,numOfdaysPastSinceLastMonday;
            var yearnow = new Date()
            d1 = new Date(this.monthno+'/'+1+'/'+(yearnow.getFullYear()+1));
            numOfdaysPastSinceLastMonday = d1.getDay() - 1;
            d1.setDate(d1.getDate() - numOfdaysPastSinceLastMonday);
            d1.setDate(d1.getDate() + (7 * (this.weekno - d1.getWeek())));
            this.rangeIsFrom = (d1.getFullYear()+ '-' + (d1.getMonth() >= 9 ? (d1.getMonth() + 1) : "0"+ (d1.getMonth() + 1) ) + "-" + (d1.getDate() >= 10 ? (d1.getDate()) : "0"+ (d1.getDate()) ));
            
           
            d1.setDate(d1.getDate() + 1);
            d2 = (d1.getFullYear()+ '-' + (d1.getMonth() >= 9 ? (d1.getMonth() + 1) : "0"+ (d1.getMonth() + 1) ) + "-" + (d1.getDate() >= 10 ? (d1.getDate()) : "0"+ (d1.getDate()) ));
            
            d1.setDate(d1.getDate() + 1);
            d3 = (d1.getFullYear()+ '-' + (d1.getMonth() >= 9 ? (d1.getMonth() + 1) : "0"+ (d1.getMonth() + 1) ) + "-" + (d1.getDate() >= 10 ? (d1.getDate()) : "0"+ (d1.getDate()) ));

            d1.setDate(d1.getDate() + 1);
            d4 = (d1.getFullYear()+ '-' + (d1.getMonth() >= 9 ? (d1.getMonth() + 1) : "0"+ (d1.getMonth() + 1) ) + "-" + (d1.getDate() >= 10 ? (d1.getDate()) : "0"+ (d1.getDate()) ));

            d1.setDate(d1.getDate() + 1);

            this.rangeIsTo = (d1.getFullYear()+ '-' + (d1.getMonth() >= 9 ? (d1.getMonth() + 1) : "0"+ (d1.getMonth() + 1) ) + "-" + (d1.getDate() >= 10 ? (d1.getDate()) : "0"+ (d1.getDate()) ));
            
            let dateArray = [this.rangeIsFrom,d2,d3,d4,this.rangeIsTo]
            
            
            let finalDateArray = []
            let countDate = 0
           
            for(let x = 0  ; x <= dateArray.length ; x++){
                let getDate = new Date(dateArray[x])
                
                if((getDate.getMonth()+1) == this.monthno){

                    let dateFormat = (getDate.getFullYear()+ '-' + (getDate.getMonth() >= 9 ? (getDate.getMonth() + 1) : "0"+ (getDate.getMonth() + 1) ) + "-" + (getDate.getDate() >= 10 ? (getDate.getDate()) : "0"+ (getDate.getDate()) ));

                    finalDateArray.push(dateFormat)
                   
                    countDate +=1
                    
                }
                
                

            }
            this.rangeIsFrom = finalDateArray[0]
            this.date = id.date ? id.date : this.rangeIsFrom
            countDate-=1
            this.rangeIsTo = finalDateArray[countDate]
            this.teams=id.teams
            this.time=id.time
            this.linked=id.link
            this.onecri=id.criteria['onecri']
            this.twocri=id.criteria['twocri']
            this.threecri=id.criteria['threecri']
            this.fourcri=id.criteria['fourcri']
            this.fivecri=id.criteria['fivecri']
            this.sixcri=id.criteria['sixcri']
            this.sevencri=id.criteria['sevencri']
            this.eightcri=id.criteria['eightcri']
            this.ninecri=id.criteria['ninecri']
            this.tencri=id.criteria['tencri']
        },

        SaveCri(){
            this.radioFailed = ''


            if(this.$refs.form.validate() && (this.onecri != '' && this.twocri != '' && this.threecri != '' && this.fourcri != '' && this.fivecri != '' && this.sixcri != '' && this.sevencri != '' && this.eightcri != '' && this.ninecri != '' && this.tencri != '' )){
                
                this.radioFailed = ''

                 axios.post('http://localhost/megatalking/performance/tutorperf.php',this.post).catch(error=>console.log('this is the error '+error))

                Vue.prototype.$scores= parseFloat(this.onecri) + parseFloat(this.twocri) + parseFloat(this.threecri) + parseFloat(this.fourcri) + parseFloat(this.fivecri) + parseFloat(this.sixcri) + parseFloat(this.sevencri) + parseFloat(this.eightcri) + parseFloat(this.ninecri) + parseFloat(this.tencri)

                this.$emit('updateWeek',this.post)
                

                
                
            
            } else {

                    this.radioFailed = "Please Fill Out All Criteria"


                }

           
            
           

        },

        pauseAudioPro(){
            Vue.prototype.$audiopro.pause();
            Vue.prototype.$audiopro.currentTime = 0 ;
        },
        swipe(direction) {

            if (direction == 'Left') {
                this.swipeDirection = true;
            } else if (direction == 'Right') {
                this.swipeDirection = false;
            }
        }
    },

}
</script>
<style scoped>
#weeklyBg{
    background-color: rgb(246, 246, 246);
}
.boxbg {
    background-color:#F6F6F6 !important;
}
.monsterrat{
   font-family: 'Montserrat', serif !important;
}
html {
    font-family: 'Montserrat', serif !important;
    overflow-y: hidden !important;
}
.input-size{
    max-width: 142px !important;
}
.select-input{
    max-width: 142px !important;
}
.header{
    background-color:#E5E5E5;
    
}
.criteria{
    background-color: white !important;
}
@media only screen and (max-width: 1200px) {
.input-size{
            max-width: 100% !important;
}
.select-input{
    max-width: 82% !important;
}
.header{
    width: 100% !important;
    
}
}
</style>